const userDataFormDE = {
    "view": {
        "title": "Vervollständigen Sie Ihre Informationen",
        "stepZero": {
            "title": "Erklärung",
            "form": {
                "label": {
                    "declarationPoint1": "Durch die Bereitstellung dieser Informationen erkennen Sie an und stimmen zu, dass sie nach bestem Wissen und Gewissen bereitgestellt werden. Wir bemühen uns sicherzustellen, dass alle Informationen korrekt und wahrheitsgemäß sind.",
                    "declarationPoint2": "Bitte beachten Sie, dass die Angabe falscher Informationen oder die falsche Darstellung der Wahrheit erhebliche Konsequenzen haben kann. Wir fordern alle Benutzer auf, die von ihnen bereitgestellten Informationen zu überprüfen und diese Plattform verantwortungsbewusst zu nutzen.",
                    "declarationPoint3": "Die Haftung für falsche Informationen oder Fehler liegt ausschließlich bei der Person, die die Informationen bereitstellt. Wir übernehmen keine Verantwortung für die Folgen von falschen oder irreführenden Informationen, die von Benutzern bereitgestellt werden.",
                    "declarationPoint4": "Durch Klicken auf <strong>'Weiter'</strong> stimmen Sie diesen Bedingungen zu und bestätigen, dass Sie sich der Auswirkungen der Bereitstellung ungenauer oder falscher Informationen voll bewusst sind.",
                    "declarationAgreement": "Ich stimme den oben genannten Bedingungen voll zu und verstehe sie."
                },
                "button": {
                    "next": "Weiter"
                }
            }
        },
        "stepOne": {
            "title": "Persönliche Informationen",
            "form": {
                "label": {
                    "firstName": "Vorname",
                    "lastName": "Nachname",
                    "streetAndNumber": "Straße und Nummer",
                    "zipCode": "Postleitzahl",
                    "city": "Stadt",
                    "country": "Land"
                },
                "placeholder": {
                    "country": "Land auswählen"
                },
                "help_text": {
                    "firstName": "Wenn Sie sich als GmbH oder andere Geschäftseinheit registrieren, wird dieses Feld für den Vornamen des Geschäftsführers verwendet.",
                    "lastName": "Wenn Sie sich als GmbH oder andere Geschäftseinheit registrieren, wird dieses Feld für den Nachnamen des Geschäftsführers verwendet.",
                    "country": "Wenn Sie sich als GmbH oder andere Geschäftseinheit registrieren, wird dieses Feld für das Land des Geschäftsführers verwendet."
                },
                "button": {
                    "next": "Weiter"
                }
            }
        },
        "stepTwo": {
            "title": "Geschäftsinformationen",
            "form": {
                "label": {
                    "businessType": "Geschäftstyp",
                    "companyName": "Firmenname",
                    "businessStreet": "Straße und Nummer",
                    "businessCity": "Stadt",
                    "businessZip": "Postleitzahl",
                    "businessCountry": "Land",
                    "ceoFirstName": "Rechtlicher Vertreter / Geschäftsführer Vorname",
                    "ceoLastName": "Rechtlicher Vertreter / Geschäftsführer Nachname",
                    "tradeRegistryExport": "Handelsregisterauszug",
                    "tradeRegistryCompanyUrl": "URL des Handelsregisters der Firma",
                    "vatNumber": "Umsatzsteuer-Identifikationsnummer",
                    "taxNumber": "Steuernummer"
                },
                "option": {
                    "businessType": {
                        "soleProprietorship": "Einzelunternehmen",
                        "limitedLiabilityCompany": "Gesellschaft mit beschränkter Haftung",
                        "partnershipOrganized": "Organisierte Partnerschaft",
                        "publicLimitedCompanyByShares": "Aktiengesellschaft",
                        "other": "Andere"
                    }
                },
                "placeholder": {
                    "businessType": "Geschäftstyp auswählen",
                    "businessCountry": "Land auswählen"
                },
                "help_text": {
                    "companyName": "Der Firmenname sollte mit dem übereinstimmen, was ursprünglich bei Stripe eingereicht wurde. Ändern Sie ihn nur, wenn er von dem ursprünglich Eingereichten abweicht.",
                    "tradeRegistryExport": "Bitte stellen Sie einen offiziellen Handelsregisterauszug Ihres Unternehmens bereit. Nur PDF, maximale Dateigröße 5 MB. Wenn Sie Hilfe beim Auffinden Ihres Handelsregisterauszugs benötigen, wenden Sie sich bitte an das Register in Ihrem Land. Eine inoffizielle Liste der Register finden Sie <1>hier</1>.",
                    "tradeRegistryCompanyUrl": "Bitte geben Sie Ihre Unternehmens-URL im Handelsregister Ihres Landes an. Wenn Ihr Register dies nicht unterstützt, fügen Sie bitte nur eine Register-URL ein."
                },
                "button": {
                    "previous": "Zurück",
                    "next": "Weiter"
                }
            }
        },
        "stepThree": {
            "title": "Bestätigung",
            "form": {
                "label": {
                    "personalInformation": "Persönliche Informationen",
                    "personalName": "Name",
                    "personalAddress": "Adresse",
                    "businessInformation": "Geschäftsinformationen",
                    "companyName": "Firma",
                    "ceoName": "Geschäftsführername",
                    "businessAddress": "Adresse",
                    "businessType": "Geschäftstyp",
                    "taxNumber": "Steuernummer",
                    "vatNumber": "Umsatzsteuer-Identifikationsnummer",
                    "tradeRegistryExportUploaded": "Handelsregisterauszug hochgeladen",
                    "tradeRegistryCompanyUrl": "URL des Handelsregisters der Firma",
                    "notAvailable": "N/A"
                },
                "button": {
                    "previous": "Zurück",
                    "save": "Speichern",
                    "next": "Weiter"
                }
            },
            "message": {
                "success": "Ihre Informationen wurden aktualisiert!",
                "error": "Etwas ist schief gelaufen! Bitte Seite aktualisieren und erneut versuchen!"
            },
            "modal": {
                "submitYourInformation": {
                    "header": "Reichen Sie Ihre Informationen ein",
                    "body": {
                        "point1": "Durch Klicken auf <strong>'Bestätigen'</strong> bestätigen Sie, dass alle von Ihnen bereitgestellten Informationen nach bestem Wissen und Gewissen korrekt und wahrheitsgemäß sind.",
                        "point2": "Bestätigen Sie, dass alle angegebenen Details korrekt sind und erkennen Sie die möglichen Konsequenzen der Einreichung ungenauer Informationen an?"
                    },
                    "button": {
                        "confirm": "Bestätigen",
                        "cancel": "Abbrechen"
                    }
                }
            }
        },
        "stepFour": {
            "title": "Mobilnummer verifizieren",
            "form": {
                "label": {
                    "mobileNumber": "Geben Sie Ihre Mobilnummer ein",
                    "deliveryMedium": "Übertragungsmedium: ",
                    "deliveryMediumSMS": "SMS",
                    "deliveryMediumWhatsapp": "WhatsApp",
                    "otp": "OTP"
                },
                "help_text": {
                    "mobileNumber": "Hinweis: Die Mobilnummer ist als Standardverfahren zur Verifizierung erforderlich, da sie zur Anmeldevalidierung verwendet werden kann. Sie müssen die Nummer besitzen und darauf zugreifen können, um den Verifizierungsprozess reibungslos zu gestalten.",
                    "isFormUSorCanada": "* Wenn Sie in den USA oder Kanada ansässig sind, wenden Sie sich bitte an unser Support-Team, nachdem Sie Ihre Mobilnummer eingegeben haben.",
                    "deliveryMediumWhatsapp": "Hinweis: Bitte stellen Sie sicher, dass Sie ein WhatsApp-Konto auf dieser Nummer haben, um die Nachricht zu erhalten.",
                    "otp": "Bitte geben Sie das an Ihre Mobilnummer gesendete OTP ein."
                },
                "message": {
                    "errorMobileNumberEmpty": "Mobilnummer ist erforderlich.",
                    "errorMobileNumberInvalid": "Ungültige Mobilnummer.",
                    "errorMobileNumberSame": "Diese Nummer ist bereits hinzugefügt und mit Ihrem Konto verifiziert.",
                    "errorOTPRequired": "OTP ist erforderlich.",
                    "errorOtpSendLimitExhasuted": "Sie können keine weiteren OTPs anfordern, da Sie das <strong>MAX-Limit ({{maxLimit}})</strong> für OTP-Anfragen ausgeschöpft haben. Bitte kontaktieren Sie den Support für weitere Informationen!",
                    "errorMobileUpdateLimitExhausted": "Sie können Ihre Mobilnummer nicht aktualisieren, da Sie sie bereits MAX ({{maxLimit}}) Mal aktualisiert haben. Bitte kontaktieren Sie den Support für weitere Informationen!"
                },
                "button": {
                    "sendOTP": "OTP senden",
                    "next": "Weiter",
                    "confirm": "Bestätigen",
                    "notGettingCode": "Ich erhalte den Code nicht"
                }
            },
            "message": {
                "success": "Mobilnummer verifiziert!",
                "errorValidatingOTP": "Fehler bei der Validierung des OTP!",
                "errorSendingOTP": "Es gab ein Problem beim Senden des OTP-Codes, bitte versuchen Sie es später erneut!"
            },
            "modal": {
                "notGettingCode": {
                    "header": "Ich erhalte den Code nicht",
                    "body": {
                        "point1": "Es scheint ein Problem beim Senden eines Verifizierungscodes an Sie zu geben. Bitte versuchen Sie es später erneut",
                        "point2": "Für Unterstützung wenden Sie sich bitte über das Help Center an unseren Support."
                    },
                    "button": {
                        "close": "Schließen"
                    }
                }
            },
            "resendTimer": {
                "message": {
                    "secondsRemaining": "Sie können das OTP in <strong>{{secondsRemaining}}</strong> Sekunden erneut anfordern"
                }
            }
        },
        "stepFive": {
            "title": "Identitätsverifizierung",
            "form": {
                "label": {
                    "identityVerificationDescription": "Bitte klicken Sie auf den untenstehenden Link, um die Identitätsverifizierung zu starten.",
                    "identityVerificationResults": "Ergebnisse der Identitätsverifizierung"
                },
                "button": {
                    "loading": "Laden...",
                    "verifyIdentity": "Identität verifizieren"
                },
                "table": {
                    "column": {
                        "type": "Typ",
                        "status": "Status",
                        "details": "Details"
                    },
                    "label": {
                        "selfieVerification": "Selfie-Verifizierung",
                        "documentVerification": "Dokumentenverifizierung",
                        "verified": "Verifiziert",
                        "notVerified": "Nicht verifiziert",
                        "notAvailable": "N/A"
                    }
                },
                "message": {
                    "identityVerificationSuccess": "Ihre Identitätsinformationen wurden verifiziert, unser Team wird die Identitätsinformationen überprüfen und die endgültige Genehmigung in 2-3 Werktagen erteilen.",
                    "identityVerificationFailed": "Ihre Identitätsinformationen konnten nicht verifiziert werden, bitte reichen Sie die Informationen erneut ein! Sie haben nur noch <strong>{{attemptsRemaining}}</strong> Versuch, um Ihre Identität zu verifizieren.",
                    "identityVerificationMaxAttempts": "Sie haben die maximale Anzahl von Versuchen zur Identitätsverifizierung ausgeschöpft, bitte kontaktieren Sie den Support für weitere Informationen."
                }
            }
        },
        "stepSix": {
            "title": "Vertrag unterschreiben",
            "form": {
                "label": {
                    "signContract": "Vertrag unterschreiben"
                }
            }
        },
        "stepSeven": {
            "title": "Genehmigung",
            "form": {
                "message": {
                    "approval": "Unser Team wird alle von Ihnen bereitgestellten Informationen überprüfen und die endgültige Genehmigung innerhalb von 3 Werktagen erteilen."
                }
            }
        }
    },
    "signRedirectPages": {
        "signSuccess": {
            "title": "Vertrag erfolgreich unterschrieben :)",
            "description": "Sie haben Ihren Vertrag erfolgreich unterschrieben, der Status wird in Kürze in Ihrem Konto aktualisiert, bitte aktualisieren Sie die Seite in wenigen Sekunden."
        },
        "signLater": {
            "title": "Vertrag später unterschreiben ...",
            "description": "Sie haben sich entschieden, den Vertrag später zu unterschreiben, bitte schließen Sie diesen Schritt so schnell wie möglich ab, um die Verteilung zu ermöglichen."
        },
        "signDeclined": {
            "title": "Vertragsunterzeichnung abgelehnt :(",
            "description": "Sie haben sich geweigert, den Vertrag zu unterschreiben, dies wird den Prozess zur Aktivierung der Verteilung verzögern."
        },
        "signCompleted": {
            "title": "Vertragsunterzeichnung abgeschlossen :)",
            "description": "Ihr Vertrag wurde abgeschlossen, der Status wird in Kürze in Ihrem Konto aktualisiert, bitte aktualisieren Sie die Seite in wenigen Sekunden."
        }
    }
};

export default userDataFormDE;